import { baseUrl } from "./Configuration";

export const refreshAccessToken = async () => {
    const url = baseUrl + "/api/auth/refresh-token";

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
    }).then((response) => {
        if (!response.ok) {
            throw new Error('Token refresh failed');
        }
        return response.json();
    })
    .then((data) => {
        // Store the new access_token in localStorage
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("expires_at", (Date.now() + data.expires_in * 1000).toString());
        return data.access_token;
    })
    .catch((err) => {
        console.error('Error refreshing token:', err);
        // Check if this is a logout scenario (no token in storage)
        const currentToken = localStorage.getItem('token');
        if (!currentToken) {
            console.log('Token refresh failed - appears to be logout scenario');
            return null;
        }
        // Clear tokens and redirect to login only if not already logged out
        localStorage.removeItem('token');
        localStorage.removeItem('expires_at');
        window.location.href = '/login';
        return null;
    });
};